import { useParams } from "react-router-dom";

import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";

import { FoBankContactEditCard } from "./edit_card";

const client = "fo-quantilia";
const table_name = "fo_bank_contact";

export const FoBankContactCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <FoBankContactEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
